// Same constants and math as backend/radar_logic.py (frame, norm_size), so overlay pins land on the coordinates.
const PAD_X = 24;
const PAD_TOP = 46;
const PAD_BOTTOM = 14;

export function normSize(w, h) {
  const W = Math.max(1, Math.round(w));
  const H = Math.max(1, Math.round(h));
  const k = Math.min(1, 640 / W, 640 / H);
  return [Math.max(64, Math.round(W * k)), Math.max(64, Math.round(H * k))];
}

function world(lat, lng) {
  const s = Math.min(Math.max(Math.sin((lat * Math.PI) / 180), -0.9999), 0.9999);
  return [256 * (0.5 + lng / 360), 256 * (0.5 - Math.log((1 + s) / (1 - s)) / (4 * Math.PI))];
}

const latFromY = (y) => (Math.atan(Math.sinh(Math.PI - (2 * Math.PI * y) / 256)) * 180) / Math.PI;
const round6 = (v) => Math.round(v * 1e6) / 1e6;

// Returns each marker with x/y in % of a w x h Static Map image (tip position).
export function placePins(markers, w, h, dots = []) {
  return placeWith([...markers, ...dots], markers, w, h);
}

// Ranks 4-10: projected on the frame of the top 3 + V (the map image framing), outside points dropped.
export function placeDots(markers, dots, w, h) {
  if (!markers?.length || !dots?.length) return [];
  return placeWith([...markers, ...dots], dots, w, h);
}

function placeWith(markers, items, w, h) {
  const pts = markers.map((m) => world(m.lat, m.lng));
  const xs = pts.map((p) => p[0]);
  const ys = pts.map((p) => p[1]);
  const [minx, maxx, miny, maxy] = [Math.min(...xs), Math.max(...xs), Math.min(...ys), Math.max(...ys)];
  let zoom = 15;
  if (pts.length > 1) {
    zoom = 3;
    for (let z = 16; z > 2; z--) {
      const s = 2 ** z;
      if ((maxx - minx) * s <= w - 2 * PAD_X && (maxy - miny) * s <= h - PAD_TOP - PAD_BOTTOM) {
        zoom = z;
        break;
      }
    }
  }
  const s = 2 ** zoom;
  const cx = (minx + maxx) / 2;
  const cy = (miny + maxy) / 2 - (PAD_TOP - PAD_BOTTOM) / (2 * s);
  const [ccx, ccy] = world(round6(latFromY(cy)), round6((cx / 256 - 0.5) * 360));
  return items.map((m) => {
    const [px, py] = world(m.lat, m.lng);
    return { ...m, x: (((px - ccx) * s + w / 2) / w) * 100, y: (((py - ccy) * s + h / 2) / h) * 100 };
  });
}
